import React from 'react';
import { createRoot } from 'react-dom/client';
import { BookingFilters } from './components/BookingFilters';
import '../../_shared/oceanSearchContext';

document.addEventListener('DOMContentLoaded', () => {
	const containers = document.querySelectorAll<HTMLElement>('.wp-block-ocean-booking-filters');

	containers.forEach((container) => {
		const features = window.oceanSearchData?.features || [];
		const locations = window.oceanSearchData?.locations || [];
		const collections = window.oceanSearchData?.collections || [];
		const showTrigger = container.dataset.showTrigger !== 'false';

		const root = createRoot(container);
		root.render(<BookingFilters features={features} locations={locations} collections={collections} showTrigger={showTrigger} />);
		});
	});
